import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = (event) => {
    if (event.detail?.data?.didError) return;

    this.#openAfterCartMorph();
  };

  /**
   * Opens the drawer after cart section morph completes.
   * Cart HTML is morphed synchronously during the cart:update event, which
   * resets the dialog if we open too early.
   */
  #openAfterCartMorph(attempt = 0) {
    if (!document.querySelector('cart-drawer-component[auto-open]')) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const drawer = document.querySelector('cart-drawer-component');

        if (!(drawer instanceof CartDrawerComponent) || !drawer.hasAttribute('auto-open')) {
          if (attempt < 8) {
            setTimeout(() => this.#openAfterCartMorph(attempt + 1), 100);
          }
          return;
        }

        drawer.open();

        requestAnimationFrame(() => {
          if (!drawer.refs.dialog?.open && attempt < 8) {
            setTimeout(() => this.#openAfterCartMorph(attempt + 1), 100);
          }
        });
      });
    });
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
